import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Typography } from "antd";
import { useUser } from "../../context/UserContext";
import { getProductosCerca } from "../../utils/productos/productosCercaUtils";
import { ListaProductoItemBuscador } from "../ProductosBuscador/ListaProductoItemBuscador";
import { addToCart } from "../../utils/productos/productoUtils";
import "./ProductosCerca.scss";
import CustomSectionCard from "../CustomSectionCard/CustomSectionCard";
import { handleFavoriteProductoAction } from "../../utils/favoritos/favoritosUtils";
import SkeletonCard from "../SkeletonCard/SkeletonCard"; // Asegúrate de importar tu Skeleton

const { Text } = Typography;

const ProductosCerca = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true); // 🔥 Estado de carga
  const [meta, setMeta] = useState({ fueraDeRango: false, sinTiendas: false });
  const { userLocation, userData, userFavorites } = useUser();
  const userFavoritesRef = useRef(userFavorites);

  useEffect(() => {
    if (!userLocation) return undefined;
    // Si la ubicación cambia mientras se consulta, se ignora la respuesta anterior
    let vigente = true;
    setLoading(true);
    getProductosCerca(userLocation, userFavoritesRef.current, (data) => {
      if (!vigente) return;
      setProducts(data);
      setLoading(false);
    }, (m) => vigente && setMeta(m));
    return () => {
      vigente = false;
    };
  }, [userLocation]);

  // Los favoritos solo actualizan el corazón; no vuelven a consultar los productos
  useEffect(() => {
    userFavoritesRef.current = userFavorites;
    const favoritos = (userFavorites && userFavorites.productos) || [];
    setProducts((prev) => prev.map((p) => ({ ...p, isFavorite: favoritos.includes(p.id) })));
  }, [userFavorites]);

  const handleFavoriteToggle = async (productId, isFavorite) => {
    const updatedProducts = products.map((producto) => {
      if (producto.id === productId) {
        return { ...producto, isFavorite: !isFavorite };
      }
      return producto;
    });
    setProducts(updatedProducts);
    const action = isFavorite ? "remove" : "add";
    handleFavoriteProductoAction(productId, action, userData);
  };
    
  return (
    <div className="productos-cerca-section">
      <CustomSectionCard
        title="Productos cerca de ti"
        subtitle="Explora lo que hay a tu alrededor"
      >
        {!loading && meta.sinTiendas && (
          <Text type="secondary">Aún no hay tiendas con ubicación registrada cerca de ti.</Text>
        )}
        {!loading && meta.fueraDeRango && (
          <Text type="secondary">No hay tiendas a menos de 50 km. Te mostramos las más cercanas.</Text>
        )}
        <Row
          gutter={[
            { xs: 8, sm: 16, md: 24 }, // Ajustado para mejor look en móvil
            { xs: 12, sm: 24, md: 32 },
          ]}
          justify="start"
          className="products-grid"
        >
          {loading ? (
            // 🔥 Muestra 4 o 6 recuadros fantasmas mientras carga
            [1, 2, 3, 4, 5, 6].map((key) => (
              <Col xs={12} sm={12} md={8} lg={8} xl={6} key={key}>
                <SkeletonCard />
              </Col>
            ))
          ) : (
            // Muestra los productos reales
            products.map((producto) => (
              <Col xs={12} sm={12} md={8} lg={8} xl={6} key={producto.id}>
                <ListaProductoItemBuscador
                  producto={producto}
                  addToCart={() => addToCart(producto, userData)}
                  favorite={() => handleFavoriteToggle(producto.id, producto.isFavorite)}
                  isFavorite={producto.isFavorite}
                />
              </Col>
            ))
          )}
        </Row>
      </CustomSectionCard>
    </div>
  );
};

export default ProductosCerca;